'use client'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <div className='flex min-h-screen flex-col items-center justify-center'>
      <h2 className='text-2xl font-bold'>Algo salió mal</h2>
      <p className='mt-2 text-gray-600'>{error.message}</p>
      <button
        onClick={() => reset()}
        className='mt-6 rounded-md bg-gray-800 px-4 py-2 text-white hover:bg-gray-700'
      >
        Intentar de nuevo
      </button>
    </div>
  )
}
